 var owl = jQuery('.logolist .owl-carousel');
      owl.owlCarousel({
        margin: 60,
		nav: true,
        dots: false,
        loop: true,
         autoplay:false,
    autoplayTimeout:3000,
    autoplayHoverPause:true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          1000: {
            items: 3
          },
          1200: {
            items: 6
          }
        }
});

jQuery(document).ready(function($) {
      jQuery('.slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1
           }
        }]
    });
});